import { useGameCreator, type MissionPhase } from "@/contexts/GameCreatorContext";
import { Users, Gamepad2, Shield, Megaphone, Rocket } from "lucide-react";
import { motion } from "framer-motion";

const phases: { id: MissionPhase; label: string; icon: React.ElementType }[] = [
  { id: "audience", label: "Audience", icon: Users },
  { id: "design", label: "Design", icon: Gamepad2 },
  { id: "rules", label: "Validate", icon: Shield },
  { id: "marketing", label: "Marketing", icon: Megaphone },
  { id: "launch", label: "Launch", icon: Rocket },
];

const phaseOrder: MissionPhase[] = ["welcome", "audience", "design", "rules", "marketing", "launch"];

export default function MissionTimeline() {
  const { phase, phaseProgress } = useGameCreator();
  const currentIdx = phaseOrder.indexOf(phase);

  return (
    <div className="flex items-center gap-1 px-4 py-3">
      {phases.map((p, i) => {
        const pIdx = phaseOrder.indexOf(p.id);
        const isActive = pIdx === currentIdx;
        const isComplete = phaseProgress[p.id] === 100;
        const isPast = pIdx < currentIdx;
        const Icon = p.icon;

        return (
          <div key={p.id} className="flex items-center gap-1 flex-1">
            <motion.div
              className={`flex items-center gap-1.5 px-2 py-1.5 rounded-md text-xs font-medium transition-all duration-300 ${
                isActive
                  ? "bg-neon/15 text-neon border border-neon/30"
                  : isPast || isComplete
                  ? "bg-neon/8 text-neon/70"
                  : "text-muted-foreground/50"
              }`}
              animate={isActive ? { scale: [1, 1.02, 1] } : {}}
              transition={{ duration: 2, repeat: Infinity }}
            >
              <Icon className="w-3.5 h-3.5" />
              <span className="hidden lg:inline">{p.label}</span>
            </motion.div>
            {i < phases.length - 1 && (
              <div className="flex-1 h-px bg-border relative overflow-hidden min-w-[8px]">
                {(isPast || isComplete) && (
                  <motion.div
                    className="absolute inset-0 bg-neon/40"
                    initial={{ scaleX: 0 }}
                    animate={{ scaleX: 1 }}
                    transition={{ duration: 0.5 }}
                    style={{ transformOrigin: "left" }}
                  />
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
